"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BACKGROUND_DELETE = void 0;
var BACKGROUND_DELETE = exports.BACKGROUND_DELETE = 'backgroundDelete';